import { useMemo } from 'react'

import { useMyAssessmentAverages } from '../services/users.convex'
import { processTimeseries } from '../utils/positionProgressChart.utils'
import { PositionProgressChart } from './PositionProgressChart'

/**
 * Progress chart for the currently authenticated user, sourced from Convex.
 *
 * No userId prop is required — identity is resolved server-side via the
 * Convex auth session. Use this on the user's own dashboard. For viewing
 * another user's data (e.g. a direct report), use ConnectedPositionProgressChart.
 */
export function ConvexPositionProgressChart() {
  const { data: timeseries, isLoading, error } = useMyAssessmentAverages()

  const chartData = useMemo(() => processTimeseries(timeseries), [timeseries])

  return (
    <PositionProgressChart
      data={chartData}
      isLoading={isLoading}
      error={error}
    />
  )
}
